/**
 * DASHBOARD-HISTORY-SKELETON.WIDGET
 * Skeleton adapté à dashboard-history.widget.tsx : panneau blanc sans cadre (comme la page chargée), menu des
 * lignes, en-têtes de dates inclinés, puis des lignes à trois niveaux de texte (axe, thème, question) et trois
 * valeurs dont la première porte la pastille d'évolution.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"

const ROW_COUNT = 6
const LABEL_WIDTH = 420
const COLUMN_WIDTH = 64

export default function DashboardHistorySkeletonWidget() {
  return (
    <div className="rel" style={{ background: "white", overflow: "hidden", padding: "24px 32px" }}>
      <div className="flex" style={{ alignItems: "flex-end", height: 84, marginBottom: 16 }}>
        <div style={{ width: LABEL_WIDTH, flexShrink: 0 }}>
          <Skeleton width={150} height={34} borderRadius={8} />
        </div>
        <div className="flex">
          {[0, 1, 2].map((i) => (
            <div key={i} className="rel" style={{ width: COLUMN_WIDTH, height: 56 }}>
              <Skeleton
                width={70}
                height={11}
                style={{ position: "absolute", left: 0, bottom: 0, transform: "rotate(-45deg)", transformOrigin: "bottom left" }}
              />
            </div>
          ))}
        </div>
      </div>

      {Array.from({ length: ROW_COUNT }).map((_, row) => (
        <div key={row} className="flex items-center" style={{ padding: "16px 0", borderTop: "1px solid #f0f0f0" }}>
          <div style={{ width: LABEL_WIDTH, flexShrink: 0, paddingRight: 40 }}>
            <Skeleton width={150} height={9} />
            <Skeleton width={110} height={9} style={{ margin: "7px 0" }} />
            <Skeleton width={row % 2 === 0 ? "88%" : "66%"} height={13} />
          </div>
          <div className="flex items-center" style={{ width: COLUMN_WIDTH, gap: 8 }}>
            <Skeleton width={26} height={13} />
          </div>
          <div style={{ width: COLUMN_WIDTH }}>
            <Skeleton width={26} height={13} />
          </div>
          <div style={{ width: COLUMN_WIDTH }}>
            <Skeleton width={26} height={13} />
          </div>
        </div>
      ))}

      <SkeletonShine />
    </div>
  )
}
